import { Component, Input, ViewChild } from '@angular/core';
import { PagedList } from '../../core/models/paged-list';
import { Message } from '../../core/models/message';
import { MatTableDataSource } from '@angular/material/table';
import { MessageService } from '../../core/services/message.service';
import { MatterService } from '../../core/services/matter.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router, UrlTree } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { map, tap } from 'rxjs';
import { MessageListService } from '../../core/services/message-list.service';

@Component({
  selector: 'app-sent-list',
  templateUrl: './sent-list.component.html',
  styleUrl: './sent-list.component.scss'
})
export class SentListComponent {

  pagedMessages?: PagedList<Message>;
  pagedSentMessages?: PagedList<Message>;
  ureadMessages: number = 0;
  loading = false;
  newMessageText = SentListComponent.getNewMessageText(false);
  pageSize = 5;
  pageIndex = 0;

  pageEvent: PageEvent | undefined;
  
 dataSource = new MatTableDataSource(this.pagedMessages?.items);

@Input() matterId?: string;
@ViewChild(MatPaginator) paginator!: MatPaginator;


  constructor(private messageListService: MessageListService, private bpObserver: BreakpointObserver, private router: Router) {
    
    this.bpObserver.observe(Breakpoints.XSmall).subscribe(result => {
      this.newMessageText = SentListComponent.getNewMessageText(result.matches);
    });

  }

  ngOnInit(): void {

    // need to get inbox unread messages for badge
    this.messageListService.unreadMessageCount$.subscribe((messages) => {
        this.ureadMessages = messages;
    });

      this.messageListService.loading$.subscribe((loading) => {
      this.loading = loading;
    });

 
    this.messageListService.sentMessages$.subscribe((messages) => {
        this.pagedSentMessages = messages;
        this.dataSource.data = messages.items;
       
    });

 
    this.messageListService.getInboxMessages(this.matterId, this.pageIndex + 1, this.pageSize);
    this.messageListService.getUnreadMessages();
    this.messageListService.getSentMessages(this.matterId, this.pageIndex + 1, this.pageSize);

  }

  refreshMessages() {
   this.messageListService.refreshSentMessages(this.matterId, this.pageIndex + 1, this.pageSize);
   this.messageListService.refreshInboxMessages(this.matterId, this.pageIndex + 1, this.pageSize);
   this.messageListService.refreshUnreadMessages();
  }

  static getNewMessageText(abbreviate: boolean) : string {
    return abbreviate ? 'New' : 'New Message';
  }

    handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.messageListService.refreshSentMessages(this.matterId, e.pageIndex + 1, e.pageSize);
  }

    
      getComposeMessageRouterLink() : UrlTree {
  
       return this.router.createUrlTree(['/message-compose'], { queryParams: { returnUrl: this.router.url } });
       
      }

}